// @ts-nocheck
/**
 * Returns the appropriate unit for a given forecast type
 * @param forecastType The type of forecast (e.g., 'precipitation', 'wind', 'temperature')
 * @returns The unit string for the forecast type
 */
export const getForecastUnit = (forecastType: string): string => {
  // Strip any prefix for determination
  let baseType = forecastType;
  if (forecastType.startsWith('hrrr-')) {
    baseType = forecastType.substring(5);
  } else if (forecastType.startsWith('graphcast-')) {
    baseType = forecastType.substring(10);
  }
  
  switch (baseType) {
    case 'precipitation':
      return 'mm';
    case 'wind':
    case 'wind80m':
      return 'm/s';
    case 'windpower':
      return 'MW';
    case 'temperature':
      return '°C';
    case 'humidity':
      return '%';
    case 'solar':
      return 'W/m²';
    default:
      return '';
  }
};

/**
 * Finds the index of the closest time in a forecast data array to a target time
 * @param forecastData Array of forecast data points with 'x' property as date string
 * @param targetTime Target time to find the closest match for
 * @returns Index of the closest time in the forecastData array, or -1 if data is invalid
 */
export const findClosestTimeIndex = (forecastData: any[], targetTime: Date): number => {
  if (!forecastData || !forecastData.length) return -1;
  
  let closestIndex = 0;
  let closestDiff = Math.abs(new Date(forecastData[0].x) - targetTime);
  
  for (let i = 1; i < forecastData.length; i++) {
    const diff = Math.abs(new Date(forecastData[i].x) - targetTime);
    if (diff < closestDiff) {
      closestDiff = diff;
      closestIndex = i;
    }
  }
  
  return closestIndex;
};

const getBaseChannel = (channel) => {
  let baseChannel;
  if(channel.startsWith('hrrr-')) {
    baseChannel = channel.slice(5); // removes first 5 characters
  } else if(channel.startsWith('gefs50-')) {
    forecastModel = "gefs50"
    baseChannel = channel.slice(7);
  } else if(channel.startsWith('gefs25-')) {
    forecastModel = "gefs25"
    baseChannel = channel.slice(7);
  } else {
    console.log("FORECAST CHANNEL NOT RECOGNIZED or not set")
    // debugger
  }
  return baseChannel
}

/**
 * Navigates through forecast data structures to extract the specific time-series data array
 * for a given forecast configuration.
 * 
 * @param dataObj Main forecast data object (GEFS thefwData, null for HRRR/Graphcast)
 * @param type Forecast type (e.g., 'precipitation', 'wind', 'hrrr-wind')
 * @param variation Data variation (e.g., 'Hourly', 'Speed', 'Direction')
 * @param channel Data channel (e.g., 'control', 'average', 'p10', 'p90')
 * @param assetData Asset-specific forecast data containing wind80, windPower, ohhfc, graphcast
 * @param asset Asset object with windCurve data for power calculations
 * @param interpolateCurveValues Function to interpolate wind power from wind speed
 * @param setMaxWindPower Function to set maximum wind power for scaling
 * @param assetId Asset ID for logging/debugging
 * @returns Array of time-series data points or null if not found
 */
export const getForecastPath = (
  // dataObj: any,
  type: string,
  variation: string,
  channel: string,
  assetData: any,
  asset: any,
  // interpolateCurveValues: (curveData: any[], windData: any[]) => any[],
  // setMaxWindPower: (power: number) => void,
  // assetId: string
): any[] | null => {
  const wind80Data = assetData?.wind80;
  const windPower = assetData?.windPower;
  const ohhfcData = assetData?.ohhfc;
  const graphcastData = assetData?.graphcast;
  const thefw = assetData?.thefw

  // // Strip prefix if present
  let baseType = type;
  let forecastModel;
  let channelOption;

  // Craig extract these to constants
  if(channel.startsWith('hrrr-')) {
    forecastModel = "hrrr"
    channelOption = channel.slice(5); // removes first 5 characters
  } else if(channel.startsWith('gefs50-')) {
    forecastModel = "gefs50"
    channelOption = channel.slice(7);
  } else if(channel.startsWith('gefs25-')) {
    forecastModel = "gefs25"
    channelOption = channel.slice(7);
  } else {
    console.log("FORECAST CHANNEL NOT RECOGNIZED or not set")
    // debugger
  }  
  const assetId = asset.id
  
  
  // If HRRR forecast, we need to use the OHHFC data instead of THEFW (dataObj)
  // HRRR data doesn't have channels/percentiles, it's a flat array structure
  // debugger
  if (forecastModel === "hrrr") {
    if (!ohhfcData) {
      console.warn(`No OHHFC data for asset ${assetId}`);
      return null;
    }
    
    try {
      // For HRRR precipitation data
      if (baseType === 'precipitation') {
        if (variation === 'Hourly' && ohhfcData.precip && ohhfcData.precip.Hourly) {
          return ohhfcData.precip.Hourly;
        } else if (variation === 'Cumulative' && ohhfcData.precip && ohhfcData.precip.Cumulative) {
          return ohhfcData.precip.Cumulative;
        }
      }
      // For HRRR wind data (10m)
      else if (baseType === 'wind10m' && ohhfcData.wind && ohhfcData.wind.wind10) {
        const windVariation = variation || 'Speed'; 
        if (ohhfcData.wind.wind10[windVariation]) {
          return ohhfcData.wind.wind10[windVariation];
        } else {
          console.warn(`No ${windVariation} data in HRRR wind10 for asset ${assetId}`);
          // Attempt to use default wind variation if specified one doesn't exist
          // return ohhfcData.wind.wind10.Speed;
          return []
        }
      }
      // For HRRR wind data at 80m
      else if (baseType === 'wind80m' && ohhfcData.wind && ohhfcData.wind.wind80) {
        const windVariation = variation || 'Speed'; 
        if (ohhfcData.wind.wind80[windVariation]) {
          return ohhfcData.wind.wind80[windVariation];
        } else {
          console.warn(`No ${windVariation} data in HRRR wind80 for asset ${assetId}`);
          // Attempt to use default wind variation if specified one doesn't exist
          return ohhfcData.wind.wind80.Speed;
        }
      }
      else if (baseType === 'windPower' && ohhfcData.windPower) {
        // debugger
        return ohhfcData.windPower
      }
      // For HRRR temperature data
      else if (baseType === 'temperature' && ohhfcData.temp) {
        return ohhfcData.temp;
      }
      // For HRRR humidity data
      else if (baseType === 'humidity' && ohhfcData.humidity) {
        return ohhfcData.humidity;
      }
      else if (baseType === 'solarS' && ohhfcData?.solar?.solarS) {
        return ohhfcData?.solar?.solarS;
      }
      else if (baseType === 'solarL' && ohhfcData?.solar?.solarL) {
        return ohhfcData?.solar?.solarL;
      }
    } catch (error) {
      console.error(`Error accessing HRRR data for asset ${assetId}:`, error);
    }
    
    return null;
  } 
  else if (forecastModel === "gefs50") {
    if(!wind80Data) {
      console.warn(`No Graphcast data for asset ${assetId}`);
      return null;
    }
    try {
      
      if (baseType === 'wind80m' && wind80Data.interpolated) {
        const windVariation = variation || 'Speed'; 
        if (wind80Data.interpolated[windVariation]) {
          // return ohhfcData.wind.wind10[windVariation];
          if(channelOption === "average" || channelOption === "control" ) {
            return wind80Data.interpolated[windVariation][channelOption]
          } else if(["p10","p30","p50","p70","p90"].includes(channelOption)) {
            return wind80Data.interpolated[windVariation].percentiles[channelOption]
          } else {
            console.warn("channel not recognized:", channelOption )
          }
        } else {
          console.warn(`No ${windVariation} data in HRRR wind10 for asset ${assetId}`);
          // Attempt to use default wind variation if specified one doesn't exist
          return ohhfcData.wind.wind10.Speed;
        }
      }
      else if (baseType === 'windPower'&& wind80Data?.["windPower"]) {
       if(["p10","p30","p50","p70","p90","mean","control"].includes(channelOption)) {
        
        return wind80Data?.["windPower"]?.[channelOption]
      } else {
        console.warn("windPower channel not recognized:", channelOption )
      }
    }

    } catch (error) {
      console.error(`Error accessing GEFS80 data for asset ${assetId}:`, error);
    }
  }
  // If Graphcast forecast, we need to use the graphcast data instead of THEFW (dataObj)
  // Graphcast data has a similar structure to GEFS but without channels/percentiles
  else if (forecastModel === "graphcast") {
    if (!graphcastData) {
      console.warn(`No Graphcast data for asset ${assetId}`);
      return null;
    }
    
    try {
      // For Graphcast precipitation data
      if (baseType === 'precipitation') {
        if (variation === 'Hourly' && graphcastData.precip?.interpolated?.Hourly?.control) {
          return graphcastData.precip.interpolated.Hourly.control;
        } else if (variation === 'Cumulative' && graphcastData.precip?.interpolated?.Cumulative?.control) {
          return graphcastData.precip.interpolated.Cumulative.control;
        } else {
          // Fallback to any available precipitation data
          return graphcastData.precip?.interpolated?.Hourly?.control || 
                 graphcastData.precip?.interpolated?.Cumulative?.control ||
                 graphcastData.precip?.raw?.Hourly?.control ||
                 graphcastData.precip?.raw?.Cumulative?.control;
        }
      }
      // For Graphcast wind data (10m)
      else if (baseType === 'wind' && graphcastData.wind?.wind10) {
        const windVar = variation || 'Speed';
        if (graphcastData.wind.wind10.interpolated?.[windVar]) {
          return graphcastData.wind.wind10.interpolated[windVar];
        } else if (graphcastData.wind.wind10.raw?.[windVar]) {
          return graphcastData.wind.wind10.raw[windVar];
        } else {
          // Fallback to any available wind data
          return graphcastData.wind.wind10.interpolated?.Speed || 
                 graphcastData.wind.wind10.raw?.Speed ||
                 graphcastData.wind.wind10.interpolated?.Direction ||
                 graphcastData.wind.wind10.raw?.Direction;
        }
      }
      // For Graphcast temperature data
      else if (baseType === 'temperature' && graphcastData.temp) {
        if (graphcastData.temp.interpolated?.Hourly?.control) {
          return graphcastData.temp.interpolated.Hourly.control;
        } else {
          // Fallback to raw data
          return graphcastData.temp.raw?.Hourly?.control;
        }
      }
    } catch (error) {
      console.error(`Error accessing Graphcast data for asset ${assetId}:`, error);
    }
    
    return null;
  } else if (forecastModel === "gefs25") {
    if(!thefw) {
      console.warn(`No thefw data for asset ${assetId}`);
      return null;
    }
    // Standard GEFS forecasts (non-HRRR)
    console.log(thefw, type, variation, channelOption)
    // For precipitation data
    // debugger
    if (baseType === 'precipitation' && thefw?.precip?.interpolated) {
      const precipVariation = variation || "Hourly"
      if(thefw?.precip?.interpolated[precipVariation]) {
        if(channelOption === "average" || channelOption === "control" ) {
            return thefw?.precip?.interpolated[precipVariation][channelOption]
          } else if(["p10","p30","p50","p70","p90"].includes(channelOption)) {
            return thefw?.precip?.interpolated[precipVariation].percentiles[channelOption]
          } else {
            console.warn("channel not recognized:", channelOption )
          }
      }
    } 
    // For wind data (10m)
    else if (baseType === 'wind10m'&& thefw?.wind?.interpolated) {
      const windVariation = variation || 'Speed'; // Default to Speed if not specified
      // const precipVariation = variation || "Hourly"
      if(thefw?.wind?.interpolated[windVariation]) {
        if(channelOption === "average" || channelOption === "control" ) {
            return thefw?.wind?.interpolated[windVariation][channelOption]
          } else if(["p10","p30","p50","p70","p90"].includes(channelOption)) {
            return thefw?.wind?.interpolated[windVariation].percentiles[channelOption]
          } else {
            console.warn("wind10m channel not recognized:", channelOption )
          }
      }
      
    
    }
    // For temperature data
    else if (baseType === 'temperature'&& thefw?.temperature?.interpolated?.Hourly) {
      if(channelOption === "average" || channelOption === "control" ) {
        return thefw?.temperature?.interpolated?.Hourly?.[channelOption]
      } else if(["p10","p30","p50","p70","p90"].includes(channelOption)) {
        return thefw?.temperature?.interpolated?.Hourly?.percentiles[channelOption]
      } else {
        console.warn("temperature channel not recognized:", channelOption )
      }
    }
    // For humidity data
    else if (baseType === 'humidity' && thefw?.humidity?.interpolated?.Hourly) {
      if(channelOption === "average" || channelOption === "control" ) {
        return thefw?.humidity?.interpolated?.Hourly?.[channelOption]
      } else if(["p10","p30","p50","p70","p90"].includes(channelOption)) {
        return thefw?.humidity?.interpolated?.Hourly?.percentiles[channelOption]
      } else {
        console.warn("humidity channel not recognized:", channelOption )
      }
    }
    // For solar data
    else if (baseType === 'solarS' && thefw?.solar?.interpolated?.sWave) {
      if(channelOption === "average" || channelOption === "control" ) {
        return thefw?.solar?.interpolated?.sWave[channelOption]
      } else if(["p10","p30","p50","p70","p90"].includes(channelOption)) {
        return thefw?.solar?.interpolated?.sWave?.percentiles[channelOption]
      } else {
        console.warn("humidity channel not recognized:", channelOption )
      }
    }
    else if (baseType === 'solarL' && thefw?.solar?.interpolated?.lWave) {
      if(channelOption === "average" || channelOption === "control" ) {
        return thefw?.solar?.interpolated?.lWave[channelOption]
      } else if(["p10","p30","p50","p70","p90"].includes(channelOption)) {
        return thefw?.solar?.interpolated?.lWave?.percentiles[channelOption]
      } else {
        console.warn("humidity channel not recognized:", channelOption )
      }
    } else if (baseType === 'soilMoisture' && thefw?.soilMoisture?.interpolated?.Hourly) {
      if(channelOption === "average" || channelOption === "control" ) {
        return thefw?.soilMoisture?.interpolated?.Hourly[channelOption]
      } else if(["p10","p30","p50","p70","p90"].includes(channelOption)) {
        return thefw?.soilMoisture?.interpolated?.Hourly?.percentiles[channelOption]
      } else {
        console.warn("humidity channel not recognized:", channelOption )
      }
    } else if (baseType === 'snowWater' && thefw?.snowAcc?.interpolated?.Hourly) {
      if(channelOption === "average" || channelOption === "control" ) {
        return thefw?.snowAcc?.interpolated?.Hourly[channelOption]
      } else if(["p10","p30","p50","p70","p90"].includes(channelOption)) {
        return thefw?.snowAcc?.interpolated?.Hourly?.percentiles[channelOption]
      } else {
        console.warn("humidity channel not recognized:", channelOption )
      }
    }
  }
  
  // Fallback to control if specified channel isn't available
  return null;
};